document.addEventListener('DOMContentLoaded', () => {
  tabsTypeC();
});

/* Tabs Type C */
const tabsTypeC = () => {
  const tabSections = document.querySelectorAll('.js-tabs-labels');

  tabSections.forEach(section => {
    let activeIndex = 0;
    let isInViewport = false;
    const navItems = section.querySelectorAll('.js-nav-item');
    const tabs = section.querySelectorAll('.js-tab');

    // Initial viewport check
    handleVisibilityChange();

    // Nav item click logic
    navItems.forEach((nav, index) => {
      nav.addEventListener('click', () => {
        setActiveTab(index);
      });
    });

    function setActiveTab(index) {
      if (index === activeIndex) return;

      const oldTab = tabs[activeIndex];
      const newTab = tabs[index];

      oldTab.style.opacity = '0';
      oldTab.style.pointerEvents = 'none';

      setTimeout(() => {
        navItems.forEach(item => item.classList.remove('active'));
        tabs.forEach(tab => tab.classList.remove('active'));

        if (navItems[index]) navItems[index].classList.add('active');
        if (newTab) newTab.classList.add('active');

        newTab.style.opacity = '';
        newTab.style.pointerEvents = '';
        oldTab.style.opacity = '';
        oldTab.style.pointerEvents = '';
        activeIndex = index;

        // Scroll active pill into view if it's outside the visible area
        const activeNav = navItems[activeIndex];
        if (activeNav && isInViewport) {
          setTimeout(() => scrollElementIntoView(activeNav), 10);
        }
      }, 300);
    }

    // Check if element is partially visible in viewport (more lenient)
    function isElementPartiallyVisible(el) {
      const rect = el.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const windowWidth = window.innerWidth || document.documentElement.clientWidth;

      return (
        (rect.top < windowHeight && rect.top >= 0) // top edge is visible
        || (rect.bottom > 0 && rect.bottom <= windowHeight) // bottom edge is visible
        || (rect.top <= 0 && rect.bottom >= windowHeight) // element spans viewport
      ) && (
        (rect.left < windowWidth && rect.left >= 0) // left edge is visible
        || (rect.right > 0 && rect.right <= windowWidth) // right edge is visible
        || (rect.left <= 0 && rect.right >= windowWidth) // element spans viewport horizontally
      );
    }

    // Handle viewport visibility changes
    function handleVisibilityChange() {
      isInViewport = isElementPartiallyVisible(section);
    }

    // Listen for scroll and resize events
    window.addEventListener('scroll', handleVisibilityChange, { passive: true });
    window.addEventListener('resize', handleVisibilityChange, { passive: true });

    function scrollElementIntoView(element) {
      const tabsLabels = section.querySelector('.js-tabs-nav');
      if (!tabsLabels) return;

      const containerRect = tabsLabels.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      // Check if element is outside the visible area
      const isElementLeftOfContainer = elementRect.left < containerRect.left;
      const isElementRightOfContainer = elementRect.right > containerRect.right;

      if (isElementLeftOfContainer || isElementRightOfContainer) {
        // Calculate the scroll position to center the pill
        const elementOffsetLeft = element.offsetLeft;
        const containerWidth = tabsLabels.clientWidth;
        const elementWidth = element.offsetWidth;

        // Center the pill in the container
        const targetScrollLeft = elementOffsetLeft - (containerWidth / 2) + (elementWidth / 2);

        // Smooth scroll to the target position
        if (tabsLabels.scrollTo) {
          tabsLabels.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth',
          });
        } else {
          // Fallback for older browsers
          tabsLabels.scrollLeft = targetScrollLeft;
        }
      }
    }
  });
};
